// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-chat-conversation-manage-users .fi-content-card {
  height: calc(100% - 65px);
}
.fi-chat-conversation-manage-users .fi-content-card .fi-content-card-top {
  display: flex;
  align-items: center;
}
.fi-chat-conversation-manage-users .fi-content-card .fi-content-card-top.no-side-padding {
  padding-left: 0;
  padding-right: 0;
}
.fi-chat-conversation-manage-users .fi-content-card .fi-content-card-top .conversation-control-button {
  margin-left: auto;
}
.fi-chat-conversation-manage-users .fi-content-card .fi-content-card-top-button {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-chat/fi-chat-conversation/fi-chat-conversation-manage-users/fi-chat-conversation-manage-users.component.scss"],"names":[],"mappings":"AACI;EACI,yBAAA;AAAR;AAEQ;EACI,aAAA;EACA,mBAAA;AAAZ;AAEY;EACI,eAAA;EACA,gBAAA;AAAhB;AAEY;EACI,iBAAA;AAAhB;AAGQ;EACI,eAAA;AADZ","sourcesContent":[".fi-chat-conversation-manage-users {\r\n    .fi-content-card {\r\n        height: calc(100% - 65px);\r\n\r\n        .fi-content-card-top {\r\n            display: flex;\r\n            align-items: center;\r\n\r\n            &.no-side-padding {\r\n                padding-left: 0;\r\n                padding-right: 0;\r\n            }\r\n            .conversation-control-button {\r\n                margin-left: auto;\r\n            }\r\n        }\r\n        .fi-content-card-top-button {\r\n            font-size: 14px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
